import { Down } from '../../assets/icons';


export const ShowMore = ({onClick, showMore}) => {
  return (
    <button
      onClick={onClick}
      className="flex items-center text-blue-600 hover:text-blue-700 text-sm font-medium transition-colors duration-200 mt-2"
    >
      {showMore ? 'Ascunde' : 'Mai multe'}
      <Down
        className={`ml-1 h-5 w-5 transition-transform duration-200 ${
          showMore ? 'rotate-180' : ''
        }`}
      />
    </button>
  )

}